/**
 * UK Lab Chairs — Request a Quote Page Form
 * Handles the standalone /pages/request-for-quote page form.
 * Uses pqf- prefixed IDs to avoid conflicts with the modal (qlc-) on the same page.
 */
(function () {
  'use strict';

  const NETLIFY_FUNCTION_URL = 'https://monumental-flan-503a2e.netlify.app/.netlify/functions/send-quote';

  const form         = document.getElementById('pqf-form');
  const thankyou     = document.getElementById('pqf-thankyou');
  const submitBtn    = document.getElementById('pqf-submit-btn');
  const btnText      = document.getElementById('pqf-btn-text');
  const btnSpinner   = document.getElementById('pqf-btn-spinner');
  const generalError = document.getElementById('pqf-general-error');
  const refDisplay   = document.getElementById('pqf-ref-display');
  const productRows  = document.getElementById('pqf-product-rows');


  if (!form) return;

  // ─── EMPTY STATE / PRODUCTS SECTION TOGGLE ───────────────────────────────

  function showEmptyState() {
    localStorage.removeItem('qlc_quote_items');
    var section = document.getElementById('pqf-products-section');
    var empty   = document.getElementById('pqf-empty-state');
    if (section) section.style.display = 'none';
    if (empty)   empty.style.display   = '';
  }

  // Rebuild localStorage from what's currently in the DOM rows.
  // Variants are stored as JSON in data-variants on each row so they survive re-sync.
  function syncToStorage() {
    if (!productRows) return;
    var items = [];
    productRows.querySelectorAll('.qlc-product-row').forEach(function (row) {
      var nameEl = row.querySelector('.qlc-product-name-input');
      var qtyEl  = row.querySelector('.qlc-qty-input');
      var imgEl  = row.querySelector('.qlc-product-img');
      var name   = nameEl ? nameEl.value.trim() : '';
      if (!name) return;
      var variants = [];
      try { variants = JSON.parse(row.getAttribute('data-variants') || '[]'); } catch (_) {}
      items.push({
        name:     name,
        qty:      qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1,
        image:    imgEl ? (imgEl.getAttribute('src') || '') : '',
        variants: variants
      });
    });
    if (items.length) {
      localStorage.setItem('qlc_quote_items', JSON.stringify(items));
    } else {
      showEmptyState();
    }
  }

  function showProductsSection() {
    var section = document.getElementById('pqf-products-section');
    var empty   = document.getElementById('pqf-empty-state');
    if (section) section.style.display = '';
    if (empty)   empty.style.display   = 'none';
  }

  // ─── MULTI-ROW PRODUCTS ──────────────────────────────────────────────────

  var rowCount = 1;

  function buildRowHTML(n, imgSrc, variants) {
    var trash = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>';
    var imgStyle = imgSrc ? '' : ' style="display:none"';
    var varHtml = '';
    if (variants && variants.length) {
      varHtml = '<div class="qlc-variant-details">';
      for (var v = 0; v < variants.length; v++) {
        varHtml += '<span class="qlc-variant-item">' + variants[v].label + ': ' + variants[v].value + '</span>';
      }
      varHtml += '</div>';
    }
    return '<div class="qlc-product-img-wrap"><img src="' + (imgSrc || '') + '" alt="" class="qlc-product-img"' + imgStyle + '></div>' +
      '<div class="qlc-product-name-wrap">' +
      '<input type="text" name="product_row[' + n + '][name]"' +
      ' class="qlc-input qlc-product-name-input"' +
      ' placeholder="Product name / model number"' +
      ' aria-label="Product name row ' + n + '">' +
      varHtml +
      '</div>' +
      '<div class="qlc-qty-stepper">' +
      '<button type="button" class="qlc-qty-btn qlc-qty-minus" aria-label="Decrease quantity">−</button>' +
      '<input type="number" name="product_row[' + n + '][qty]"' +
      ' class="qlc-input qlc-qty-input" value="1" min="1"' +
      ' aria-label="Quantity row ' + n + '">' +
      '<button type="button" class="qlc-qty-btn qlc-qty-plus" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button type="button" class="qlc-remove-row" aria-label="Remove row">' + trash + '</button>';
  }


  // ─── PRE-FILL FROM LOCALSTORAGE (added via PDP "Request A Quote") ─────────

  function prefillFromStorage() {
    var items = [];
    try { items = JSON.parse(localStorage.getItem('qlc_quote_items') || '[]'); } catch (_) {}
    if (!items.length || !productRows) { showEmptyState(); return; }
    showProductsSection();

    // Items are cleared only after successful submission (see submit handler below)

    // Fill the first (already-rendered) row
    var firstRow = productRows.querySelector('.qlc-product-row');
    if (firstRow) {
      var nameEl   = firstRow.querySelector('.qlc-product-name-input');
      var qtyEl    = firstRow.querySelector('.qlc-qty-input');
      var imgEl    = firstRow.querySelector('.qlc-product-img');
      var nameWrap = firstRow.querySelector('.qlc-product-name-wrap');
      if (nameEl) nameEl.value = items[0].name;
      if (qtyEl)  qtyEl.value  = items[0].qty;
      if (imgEl && items[0].image) { imgEl.src = items[0].image; imgEl.style.display = ''; }
      firstRow.setAttribute('data-variants', JSON.stringify(items[0].variants || []));
      if (nameWrap && items[0].variants && items[0].variants.length) {
        var vDiv0 = document.createElement('div');
        vDiv0.className = 'qlc-variant-details';
        items[0].variants.forEach(function (v) {
          var sp = document.createElement('span');
          sp.className = 'qlc-variant-item';
          sp.textContent = v.label + ': ' + v.value;
          vDiv0.appendChild(sp);
        });
        nameWrap.appendChild(vDiv0);
      }
    }

    // Append rows for any additional items
    for (var i = 1; i < items.length; i++) {
      rowCount++;
      var row = document.createElement('div');
      row.className = 'qlc-product-row';
      row.setAttribute('data-row', rowCount);
      row.innerHTML = buildRowHTML(rowCount, items[i].image, items[i].variants);
      row.setAttribute('data-variants', JSON.stringify(items[i].variants || []));
      productRows.appendChild(row);
      var nameEl2 = row.querySelector('.qlc-product-name-input');
      var qtyEl2  = row.querySelector('.qlc-qty-input');
      if (nameEl2) nameEl2.value = items[i].name;
      if (qtyEl2)  qtyEl2.value  = items[i].qty;
    }

    updateRemoveButtons();
  }

  if (productRows) {
    productRows.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.qlc-remove-row');
      if (removeBtn) {
        var rows = productRows.querySelectorAll('.qlc-product-row');
        if (rows.length > 1) {
          removeBtn.closest('.qlc-product-row').remove();
          syncToStorage();
        } else {
          var nameInput = removeBtn.closest('.qlc-product-row').querySelector('.qlc-product-name-input');
          var qtyInput  = removeBtn.closest('.qlc-product-row').querySelector('.qlc-qty-input');
          var imgEl2    = removeBtn.closest('.qlc-product-row').querySelector('.qlc-product-img');
          if (nameInput) nameInput.value = '';
          if (qtyInput)  qtyInput.value  = 1;
          if (imgEl2)    { imgEl2.src = ''; imgEl2.style.display = 'none'; }
          showEmptyState();
        }
        updateRemoveButtons();
        return;
      }
      var stepperBtn = e.target.closest('.qlc-qty-btn');
      if (stepperBtn) {
        var input = stepperBtn.closest('.qlc-qty-stepper').querySelector('.qlc-qty-input');
        var val = parseInt(input.value, 10) || 1;
        if (stepperBtn.classList.contains('qlc-qty-minus')) {
          if (val > 1) input.value = val - 1;
        } else {
          input.value = val + 1;
        }
      }
    });
  }

  function updateRemoveButtons() {
    if (!productRows) return;
    var rows = productRows.querySelectorAll('.qlc-product-row');
    rows.forEach(function (row) {
      var btn = row.querySelector('.qlc-remove-row');
      if (btn) btn.style.display = 'flex';
    });
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────

  function getValue(id) {
    var el = document.getElementById(id);
    return el ? el.value : '';
  }

  function showError(fieldId, errorId) {
    var field = document.getElementById(fieldId);
    var error = document.getElementById(errorId);
    if (field) field.classList.add('is-error');
    if (error) error.classList.add('is-visible');
  }

  function clearError(fieldId, errorId) {
    var field = document.getElementById(fieldId);
    var error = document.getElementById(errorId);
    if (field) field.classList.remove('is-error');
    if (error) error.classList.remove('is-visible');
  }

  function clearAllErrors() {
    form.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });
    form.querySelectorAll('.qlc-error.is-visible').forEach(function (el) { el.classList.remove('is-visible'); });
    if (generalError) generalError.style.display = 'none';
  }

  // ─── VALIDATION ──────────────────────────────────────────────────────────

  function validateForm() {
    clearAllErrors();
    var valid = true;

    if (!getValue('pqf-fullname').trim()) { showError('pqf-fullname', 'pqf-err-fullname'); valid = false; }
    if (!getValue('pqf-org').trim())      { showError('pqf-org',      'pqf-err-org');      valid = false; }
    if (!getValue('pqf-phone').trim())    { showError('pqf-phone',    'pqf-err-phone');    valid = false; }

    var email = getValue('pqf-email').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('pqf-email', 'pqf-err-email');
      valid = false;
    }

    if (!getValue('pqf-postcode').trim()) { showError('pqf-postcode', 'pqf-err-postcode'); valid = false; }

    if (!form.querySelector('input[name="pqf_forklift"]:checked')) {
      var errFork = document.getElementById('pqf-err-forklift');
      if (errFork) errFork.classList.add('is-visible');
      valid = false;
    }

    var privacy = document.getElementById('pqf-privacy');
    if (!privacy || !privacy.checked) { showError('pqf-privacy', 'pqf-err-privacy'); valid = false; }

    return valid;
  }

  // Live clear on input
  ['pqf-fullname', 'pqf-org', 'pqf-phone', 'pqf-email', 'pqf-postcode'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', function () {
      clearError(id, id.replace('pqf-', 'pqf-err-'));
    });
  });
  var privacyCb = document.getElementById('pqf-privacy');
  if (privacyCb) privacyCb.addEventListener('change', function () {
    clearError('pqf-privacy', 'pqf-err-privacy');
  });

  // ─── COLLECT DATA ────────────────────────────────────────────────────────

  function collectFormData() {
    var data = {};

    data.full_name    = getValue('pqf-fullname').trim();
    data.organisation = getValue('pqf-org').trim();
    data.role         = getValue('pqf-role').trim();
    data.email        = getValue('pqf-email').trim();
    data.phone        = getValue('pqf-phone').trim();

    var products = [];
    form.querySelectorAll('.qlc-product-row').forEach(function (row) {
      var name = row.querySelector('.qlc-product-name-input').value.trim();
      var qty  = row.querySelector('.qlc-qty-input').value.trim();
      var variants = [];
      try { variants = JSON.parse(row.getAttribute('data-variants') || '[]'); } catch (_) {}
      if (name) products.push({ name: name, qty: qty || '1', variants: variants });
    });
    data.products    = products;
    data.required_by = getValue('pqf-date');
    data.postcode    = getValue('pqf-postcode').trim();
    data.forklift    = (form.querySelector('input[name="pqf_forklift"]:checked') || {}).value || '';
    data.notes       = getValue('pqf-notes').trim();

    data.source         = getValue('pqf-source');

    data.privacy_consent  = (document.getElementById('pqf-privacy')   || {}).checked ? 'Yes' : 'No';
    data.marketing_opt_in = (document.getElementById('pqf-marketing')  || {}).checked ? 'Yes' : 'No';

    data.page_url     = window.location.href;
    data.submitted_at = new Date().toISOString();

    data.hp_website = getValue('pqf-hp-website');
    data.turnstile_token = (typeof turnstile !== 'undefined' && window.pqfTurnstileWidgetId != null)
      ? turnstile.getResponse(window.pqfTurnstileWidgetId) : '';

    return data;
  }

  // ─── SUBMIT ──────────────────────────────────────────────────────────────

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validateForm()) {
      var firstErr = form.querySelector('.is-error, .qlc-error.is-visible');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    submitBtn.disabled = true;
    if (btnText)    btnText.style.display    = 'none';
    if (btnSpinner) btnSpinner.style.display = 'inline-block';

    var formData = collectFormData();

    fetch(NETLIFY_FUNCTION_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Server error ' + res.status);
      return res.json();
    })
    .then(function (data) {
      localStorage.removeItem('qlc_quote_items');
      form.style.display = 'none';
      if (thankyou) thankyou.style.display = 'block';
      if (refDisplay && data.reference) refDisplay.textContent = data.reference;

      if (typeof gtag === 'function') {
        gtag('event', 'quote_request_submitted', {
          event_category: 'Quote',
          organisation: formData.organisation,
          product_count: formData.products.length,
          forklift_on_site: formData.forklift,
          quote_reference: data.reference || '',
          source: formData.source
        });
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'quote_request_submitted',
          quoteData: { organisation: formData.organisation, forklift: formData.forklift, reference: data.reference || '' }
        });
      }
    })
    .catch(function (err) {
      console.error('Quote page form error:', err);
      if (generalError) generalError.style.display = 'block';
      submitBtn.disabled = false;
      if (btnText)    btnText.style.display    = 'inline';
      if (btnSpinner) btnSpinner.style.display = 'none';
      if (typeof turnstile !== 'undefined' && window.pqfTurnstileWidgetId != null) {
        turnstile.reset(window.pqfTurnstileWidgetId);
      }
    });
  });

  updateRemoveButtons();
  prefillFromStorage();

})();
